module.exports = __webpack_public_path__ + "img/CH01-014-015.bbbb3279.jpg";